import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoadPageComponent } from './pages/load-page/load-page.component';
import { SaveCardPageComponent } from './pages/save-card-page/save-card-page.component';
import { ProcessConfirmationPageComponent } from './pages/process-confirmation-page/process-confirmation-page.component';

const routes: Routes = [
  {
    path: 'load',
    component: LoadPageComponent,
  },
  {
    path: 'save-card',
    component: SaveCardPageComponent,
  },
  {
    path: 'process-confirmation',
    component: ProcessConfirmationPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CardAdministrationRoutingModule {}
